var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoRecorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 7.44277C18.3327 6.93792 18.3327 6.6855 18.2329 6.56861C18.1462 6.46719 18.0163 6.41337 17.8833 6.42383C17.7301 6.43589 17.5516 6.61438 17.1946 6.97136L14.166 9.99996L17.1946 13.0286C17.5516 13.3855 17.7301 13.564 17.8833 13.5761C18.0163 13.5866 18.1462 13.5327 18.2329 13.4313C18.3327 13.3144 18.3327 13.062 18.3327 12.5572V7.44277Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 8.16663C1.66602 6.76649 1.66602 6.06643 1.9385 5.53165C2.17818 5.06124 2.56063 4.67879 3.03104 4.43911C3.56582 4.16663 4.26588 4.16663 5.66602 4.16663H10.166C11.5661 4.16663 12.2662 4.16663 12.801 4.43911C13.2714 4.67879 13.6538 5.06124 13.8935 5.53165C14.166 6.06643 14.166 6.76649 14.166 8.16663V11.8333C14.166 13.2334 14.166 13.9335 13.8935 14.4683C13.6538 14.9387 13.2714 15.3211 12.801 15.5608C12.2662 15.8333 11.5661 15.8333 10.166 15.8333H5.66602C4.26588 15.8333 3.56582 15.8333 3.03104 15.5608C2.56063 15.3211 2.17818 14.9387 1.9385 14.4683C1.66602 13.9335 1.66602 13.2334 1.66602 11.8333V8.16663Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.e60cf335368307a06cd6fa784d0569bd.svg";
export { ForwardRef as ReactComponent };